const KEYWORD_INPUT_ID = 'keyword';
const SEARCH_AREA_INPUT_ID = 'searchArea';

const MAX_SUGGESTIONS = {
  MOBILE: {
    CATEGORY_SUGGESTIONS: 2,
    PROFILE_SUGGESTIONS: 5,
    RECENT_SEARCHES: 10,
    POPULAR_SEARCHES: 10,
    SEARCH_AREAS: 5,
  },
  DESKTOP: {
    CATEGORY_SUGGESTIONS: 10,
    PROFILE_SUGGESTIONS: 10,
    RECENT_SEARCHES: 10,
    POPULAR_SEARCHES: 10,
    SEARCH_AREAS: 10,
  },
};

const DATA_PUSH = {
  EVENT: {
    ENQUIRIES_EMAIL_CLICK: 'Enquiries - Email ID Clicked',
    WRITE_A_REVIEW_CLICKED: 'Write Review Clicked',
    FORM_SUBMIT: 'Form Submit',
    SEARCH_CLICKED: 'Site Search Clicked',
    SEARCH_CLOSED: 'Site Search-Closed',
    POPULAR_SEARCH_LIST: 'Site Search-Popular Search List Clicked',
    CATEGORY_LIST: 'Site Search-Category List Clicked',
    BUSINESS_LIST: 'Site Search-Business List Clicked',
    RECENT_SEARCH_LIST: 'Site Search-Recent Search List Clicked',
    LS_SOCIAL_MEDIA_ICON_CLICKED: 'LS - Social Media Icon Clicked',
  },
  PAGE_TYPE: {
    HOME_PAGE: 'Home page',
    PROFILE_PAGE: 'Profile Page',
    LISTING_PAGE: 'Listing Page',
    PATHNAME: 'Pathname',
  },
  FORM_TYPE: {
    REVIEW_FORM: 'WriteReview',
  },
  CTA: {
    PAGE_HEADER: 'Page Header',
    PAGE_CONTENT: 'Page Content',
    PAGE_FOOTER: 'Page Footer',
    REVIEWS_SECTION: 'Reviews Section',
    ENQUIRIES_SECTION: 'Enquiries Section',
  },
  SEARCH_TERM: {
    SEARCH_NAME: 'search business name|search location',
  },
};

export { KEYWORD_INPUT_ID, SEARCH_AREA_INPUT_ID, MAX_SUGGESTIONS, DATA_PUSH };
